import { getAuthority } from '@utils/msal/msalConfig';

//REDUX
import {
  fetchData,
  postData,
  putData,
  decommissionData,
  loginMS,
  logInWithToken,
  logInWithCredentials,
  patchData,
  postFile,
  updateData,
  deleteData,
} from '@redux/slices/functionals/request/requestActions';
import { globalActions } from '@redux/slices/states/global/globalSlice';
import { KPIActions } from '@redux/slices/states/kpi/KPISlice';

//KPIs
import { KPI_URL, KPI_CRUDURL } from '@pages/DataBase/Configuration/Kpis/constants';
import { ISessionBadge } from '@interfaces/App.interface';
import { IConfigComponent, IConfigStepper, IOrganization, IEntity, IElement, IElementType, CDocument } from '@ts/ui-models';
import { IDataGridConfig } from '@ts/storybook';

//#region SSO
export const redirectToMSA = () => {
  window.location.href = getAuthority();
};

export const logout = dispatch => {
  return dispatch(
    fetchData({
      url: '/api/v2/logout',
      dataBody: {},
      options: {
        dataAfterAction: {},
        afterAction: globalActions.logout,
      },
    })
  );
};
export const loginWithMSToken = (dispatch, token) => {
  return dispatch(
    loginMS({
      url: '/api/v2/logIn/microsoft?client=webApp',
      dataBody: { accessToken: token },
      withoutMeta: true,
      withoutMethod: true,
    })
  );
};
export const loginWithCredentials = async (dispatch, credentials) => {
  const request = await dispatch(
    logInWithCredentials({
      url: '/api/v2/logIn?client=webApp',
      dataBody: { ...credentials },
      withoutMeta: true,
      withoutMethod: true,
    })
  );
  const user = request?.payload?.data;
  if (user) {
    dispatch(globalActions.loginSuccess(user));
  } else {
  }
};
export const loginWithToken = async (dispatch) => {
  const request = await dispatch(
    logInWithToken({ url: '/api/logInWithToken', dataBody: {}, withoutMeta: true, withoutMethod: true })
  );
  const user = request?.payload?.data;

  if (user) {
    dispatch(globalActions.loginSuccess(user));
  }
};
//#endregion

//#region Roles
export const postChangeRole = async (dispatch, userId: string, roleId: string, organizationId: string) => {
  const request = await dispatch(
    postData({
      url: `/api/v2/switchRole`,
      dataBody: {
        userId,
        roleId,
        organizationId,
      },
      withoutData: true,
      withoutMeta: true,
      withoutMethod: true,
      /* options: {
          afterAction: globalActions.updateDataGridConfig,
        }, */
    })
  );
  const user = request?.payload?.data;
  if (user) {
    dispatch(globalActions.loginSuccess(user));
  }
};
//#endregion

//#region GLOBALS
export const getSettings = (dispatch, badge: ISessionBadge) => {
  return dispatch(
    fetchData({
      key: 'getSettings',
      url: '/api/getSettings',
      dataBody: { ...badge },
      options: {
        dataAfterAction: { key: 'settings' },
        afterAction: globalActions.updateGlobalState,
      },
    })
  );
};
export const getACL = (dispatch, badge: ISessionBadge) => {
  return dispatch(
    fetchData({
      key: 'global',
      url: '/api/userAcls',
      dataBody: { ...badge },
      options: {
        dataAfterAction: { key: 'aclList' },
        afterAction: globalActions.updateGlobalState,
      },
    })
  );
};

export const getReadingTypes = dispatch => {
  return dispatch(
    fetchData({
      key: 'global',
      url: '/api/readingTypes',
      //dataBody: { ...badge },
      options: {
        dataAfterAction: { key: 'readingTypesList' },
        afterAction: globalActions.updateGlobalState,
      },
    })
  );
};

export const getUnits = dispatch => {
  return dispatch(
    fetchData({
      key: 'global',
      url: '/api/units',
      //dataBody: { ...badge },
      options: {
        dataAfterAction: { key: 'unitsList' },
        afterAction: globalActions.updateGlobalState,
      },
    })
  );
};

export const getIndicators = dispatch => {
  return dispatch(
    fetchData({
      key: 'global',
      url: '/api/indicators',
      //dataBody: { ...badge },
      options: {
        dataAfterAction: { key: 'indicatorList' },
        afterAction: globalActions.updateGlobalState,
      },
    })
  );
};

export const getEventsTypes = dispatch => {
  return dispatch(
    fetchData({
      key: 'global',
      url: '/api/eventTypes',
      dataBody: {
        where: {},
        filters: {},
        sortColumn: 'name',
        sortOrder: 'ASC',
        findAndCount: false,
      },
      options: {
        dataAfterAction: { key: 'eventsTypesList' },
        afterAction: globalActions.updateGlobalState,
      },
    })
  );
};
export const getItemsTypes = dispatch => {
  return dispatch(
    fetchData({
      key: 'global',
      url: '/api/itemTypes',
      dataBody: {
        where: {
          isMaster: false,
          isAlive: true,
        },
        filters: {},
        sortColumn: 'customId',
        sortOrder: 'ASC',
        findAndCount: false,
      },
      options: {
        dataAfterAction: { key: 'elementsTypesList' },
        afterAction: globalActions.updateGlobalState,
      },
    })
  );
};
//#endregion

//#region KPIs
export const getListKPIs = dispatch => {
  return dispatch(
    fetchData({
      url: KPI_URL,
      dataBody: {
        where: {
          isAlive: true,
        },
        sortColumn: 'name',
        sortOrder: 'ASC',
      },
      options: {
        dataAfterAction: { key: 'kpiList' },
        afterAction: KPIActions.updateKPIState,
      },
    })
  );
};
export const getKPI = (dispatch, kpiId) => {
  return dispatch(
    fetchData({
      url: `${KPI_CRUDURL}/${kpiId}`,
      dataBody: {},
      options: {
        dataAfterAction: { key: 'kpiSelected' },
        afterAction: KPIActions.updateKPIState,
      },
    })
  );
};
//#endregion

//#region Settings
export const postOrganizationDefaultView = (dispatch, organizationId, itemId) => {
  return dispatch(
    postData({
      url: '/api/parameter/new',
      dataBody: {
        currentOrganizationId: organizationId,
        parameterTypeId: 'organization_defaultView',
        name: 'defaultView',
        value: {
          defaultViewId: itemId,
        },
        xTypeId: organizationId,
      },
    })
  );
};
export const postUserDefaultView = (dispatch, userId, organizationId, itemId, tile?: string, transparency?: number) => {
  return dispatch(
    postData({
      url: '/api/parameter/new',
      dataBody: {
        currentOrganizationId: organizationId,
        parameterTypeId: 'user_defaultView',
        name: 'defaultView',
        value: {
          defaultViewId: itemId,
          tile: tile,
          transparency: transparency,
        },
        xTypeId: userId,
      },
    })
  );
};
export const putUserDefaultView = (dispatch, parameterId, itemId, tile?: string, transparency?: number) => {
  return dispatch(
    updateData({
      key: 'putUserDefaultView',
      url: `/api/parameter/${parameterId}`,
      dataBody: {
        parameterTypeId: 'user_defaultView',
        value: {
          defaultViewId: itemId,
          tile: tile,
          transparency: transparency,
        },
      },
    })
  );
};
export const deleteUserDefaultView = (dispatch, userId, parameterId) => {
  return dispatch(
    decommissionData({
      url: `/api/unsetparameter`,
      dataBody: {
        parameterId: parameterId,
        type: 'user',
        xTypeId: userId,
      },
    })
  );
};
export const postDataGridConfig = (
  dispatch,
  level: string,
  componentId: string, //filterID or componentID
  dataGridConfig: IDataGridConfig,
  roleId?: string
): Promise<any> => {
  return dispatch(
    postData({
      url: `/api/dataGridConfig/${level}/${componentId}`,
      dataBody: {
        ...dataGridConfig,
      },
      meta: {
        roleId: roleId,
      },
      options: {
        afterAction: globalActions.updateDataGridConfig,
      },
    })
  );
};
//#endregion

//#region Entities
export const postNewEntity = async (dispatch, configStepper: IConfigStepper, entity: any): Promise<IEntity | null> => {
  const requestURL = configStepper.fetchURL ?? `/api/v3/${configStepper.entity}`;
  const copyEntity = { ...entity };
  delete copyEntity.tEntity;
  const result = await dispatch(
    postData({
      url: requestURL,
      dataBody: {
        ...copyEntity,
      },
    })
  );

  if (result?.payload?.data?.data) {
    return result.payload.data.data;
  }
  if (result?.payload?.data) {
    //V1-V2
    return result.payload.data;
  }
  return null;
};

export const patchEntity = (
  dispatch,
  configStepper: IConfigComponent | IConfigStepper,
  entityId,
  entity
): Promise<{ data: any; error: any }> => {
  const requestURL =
    configStepper.crudURL || configStepper.fetchURL
      ? `${configStepper.crudURL ?? configStepper.fetchURL}/${entityId}`
      : `/api/v3/${configStepper.entity}/${entityId}`;
  if (requestURL.startsWith('/api/v3')) {
    return dispatch(
      patchData({
        url: requestURL,
        dataBody: {
          ...entity,
        },
      })
    );
  } else {
    return dispatch(
      updateData({
        url: requestURL,
        dataBody: {
          ...entity,
        },
      })
    );
  }
};

export const putEntity = (
  dispatch,
  configStepper: IConfigComponent | IConfigStepper,
  entityId,
  entity
): Promise<{ data: any; error: any }> => {
  const requestURL =
    configStepper.crudURL || configStepper.fetchURL
      ? `${configStepper.crudURL ?? configStepper.fetchURL}/${entityId}`
      : `/api/v3/${configStepper.entity}/${entityId}`;
  if (requestURL.startsWith('/api/v3')) {
    return dispatch(
      putData({
        url: requestURL,
        dataBody: {
          ...entity,
        },
      })
    );
  } else {
    return dispatch(
      updateData({
        url: requestURL,
        dataBody: {
          ...entity,
        },
      })
    );
  }
};

export const deleteEntity = (
  dispatch,
  configStepper: IConfigComponent | IConfigStepper,
  entityId
): Promise<{ data: any; error: any }> => {
  const requestURL =
    configStepper.crudURL || configStepper.fetchURL
      ? `${configStepper.crudURL ?? configStepper.fetchURL}/${entityId}`
      : `/api/v3/${configStepper.entity}/${entityId}`;

  if (requestURL.startsWith('/api/v3')) {
    return dispatch(
      deleteData({
        url: requestURL,
        dataBody: {},
      })
    );
  } else {
    return dispatch(
      updateData({
        url: requestURL,
        dataBody: {
          isAlive: false,
        },
      })
    );
  }
};
//#endregion

//#region Items/Elements
export const fetchAllStatusIndicators = async (dispatch): Promise<{ rows: any[]; count: number }> => {
  const result = await dispatch(
    fetchData({
      key: 'fetchAllStatusIndicators',
      url: '/api/paginated/indicators',
      dataBody: { where: { isAlive: true }, sortColumn: 'name', sortOrder: 'ASC' },
    })
  );

  if (result?.payload?.data) {
    return result.payload.data;
  }
  dispatch(globalActions.notification(result.error?._gral));
  return { rows: [], count: 0 };
};
export const postAttachDevice = async (dispatch, itemId, deviceId): Promise<IElement | null> => {
  const result = await dispatch(
    postData({
      url: '/api/v2/attachDevice',
      dataBody: {
        elementId: itemId,
        deviceId: deviceId,
        attachMoment: new Date(),
      },
    })
  );
  return result.payload?.data ?? null;
};
export const postDetachDevice = async (dispatch, itemId, deviceId): Promise<IElement | null> => {
  const result = await dispatch(
    postData({
      url: '/api/v2/detachDevice',
      dataBody: {
        elementId: itemId,
        deviceId: deviceId,
        detachmentDate: new Date(),
      },
    })
  );
  return result.payload?.data ?? null;
};
//#endregion

//#region Files
export const uploadFile = async (dispatch, data: any, file: any): Promise<CDocument | null> => {
  const response = (
    await dispatch(
      postFile({
        url: '/api/uploadFile',
        dataBody: { data, file },
      })
    )
  ).payload.data;

  if (response) {
    return new CDocument(response);
  } else {
    return null;
  }
};
//#endregion

//Organization
export const postOrganization = (dispatch, organization: IOrganization) => {
  return dispatch(
    postData({
      url: '/api/organization/new',
      dataBody: organization,
    })
  );
};

//TEST
export const testRequest = dispatch => {
  return dispatch(
    fetchData({
      url: '/api/v2/logIn?client=webApp',
      dataBody: {
        login: 'tech3@tracktio.com',
        password: 's3cret$Trackti',
      },
      /* options: {
        dataAfterAction: { key: 'elementsTypesList' },
        afterAction: globalActions.updateGlobalState,
      }, */
    })
  );
};
